<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row mb-5">

                    <div class="col-md-12">

                        <h2 class="mb-3">
                            <i class="fa fa-search"></i>
                            {{$t('text.documentSearch.title')}}
                        </h2>


                        <div class="row">
                            <div class="col-md-6 d-flex align-items-stretch">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title">
                                            <router-link :to="{ name: 'DocumentSearchFullText' }" class="card-link">
                                                {{$t('text.documentSearch.documentSearchFullText.title')}}
                                            </router-link>
                                        </h5>
                                        <p class="card-text">
                                            <small> {{$t('text.documentSearch.documentSearchFullText.info1')}}<br/><br/>
                                                {{$t('text.documentSearch.documentSearchFullText.info2')}}
                                            </small>
                                        </p>
                                        <router-link :to="{ name: 'DocumentSearchFullText' }"
                                                     class="btn btn-primary">{{$t('text.globals.search')}}
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 d-flex align-items-stretch">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title">
                                            <router-link :to="{ name: 'DocumentSearchDetailed' }" class="card-link">
                                                {{$t('text.documentSearch.documentSearchDetailed.title')}}
                                            </router-link>
                                        </h5>
                                        <p class="card-text">
                                            <small>{{$t('text.documentSearch.documentSearchDetailed.info1')}}<br/><br/>
                                                {{$t('text.documentSearch.documentSearchDetailed.info2')}}
                                            </small>
                                        </p>
                                        <router-link :to="{ name: 'DocumentSearchDetailed' }"
                                                     class="btn btn-primary">{{$t('text.globals.search')}}
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 mt-4 d-flex align-items-stretch">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title">
                                            <router-link :to="{ name: 'DocumentSearchTectonical' }" class="card-link">
                                                {{$t('text.documentSearch.documentSearchTectonical.title')}}
                                            </router-link>
                                        </h5>
                                        <p class="card-text">
                                            <small>{{$t('text.documentSearch.documentSearchTectonical.info1')}}<br/><br/>
                                                {{$t('text.documentSearch.documentSearchTectonical.info2')}}
                                            </small>
                                        </p>
                                        <router-link :to="{ name: 'DocumentSearchTectonical' }"
                                                     class="btn btn-primary">{{$t('text.globals.search')}}
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 mt-4 d-flex align-items-stretch">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title">
                                            <router-link :to="{ name: 'DocumentSearchQuery' }" class="card-link">
                                                {{$t('text.documentSearch.documentSearchQuery.title')}}
                                            </router-link>
                                        </h5>
                                        <p class="card-text">
                                            <small>{{$t('text.documentSearch.documentSearchQuery.info1')}}<br/><br/>
                                                {{$t('text.documentSearch.documentSearchQuery.info2')}}
                                            </small>
                                        </p>
                                        <router-link :to="{ name: 'DocumentSearchQuery' }"
                                                     class="btn btn-primary">{{$t('text.globals.search')}}
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import SidebarNavigation from '../components/SidebarNavigation';
    import axios from 'axios';


    export default {
        name: 'DocumentSearch',
        components: {
            SidebarNavigation
        },

        data() {
            return {
                sites: [],
                user: {},
                error: ''
            };
        },

        beforeCreate: function () {
            document.body.className = 'dashboard';
        },

        methods: {}


    };
</script>



// WEBPACK FOOTER //
// src/pages/DocumentSearch.vue